import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import { cloneDeep, get } from 'lodash';
import React from 'react';
import { Image, SizeFittingTable } from 'src/components/Antd';
import { TableNumberInputWithSlash } from 'src/components/EditableTable/TableForm1';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { EnumTablePosition } from 'src/types/common/common';
import SkuItems from '../../Components/SkuItems';
import ExclusiveCustom from '../ExclusiveCustom';

import { useI18n } from '@/src/hooks/useRouterChange';
import { i18nGet } from '@/src/tools/tools';
import css from './css.module.less';
const widthDict = {
  productName: { minWidth: 221 },
  sku: { minWidth: 120 },
  qty: {
    width: 76,
  },
  listPrice: { width: 87 },
  discount: { width: 87 },
  sellingPrice: { width: 102 },
};
const tableName = 'additionalItem';
const ProductItemsTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    value,
    onChange,
    extendColumns,
    rowSelection,
    nonOperational,
    maxSelection,
    disabled,
    currency = 'HKD',
    isGift,
    rowKey,
  } = props;
  const _currency = currency || 'HKD';
  const rowKeySet = rowKey || 'uuid';
  const expandedRows = (value || []).map((i) => i[rowKeySet]);
  const checkedProduct = value.filter((o) => o.checked);
  const checkedAmount = checkedProduct.reduce((pre, now) => {
    const count = pre + Number(now.amount);
    return count;
  }, 0);

  const onQuantityChange = (amount, key) => {
    //修改数量时，从数据里找key相同的，改数量

    const _additionalItems = cloneDeep(value || []);
    const changeIndex = _additionalItems.findIndex((o) => o[rowKeySet] == key);
    _additionalItems[changeIndex].amount = amount;
    if (onChange) onChange(_additionalItems);
  };

  const handleRemove = (uuid) => {
    //remove专属定制
    const _additionalItems = cloneDeep(value || []);
    _additionalItems.forEach((item) => {
      if (item[rowKeySet] === uuid) {
        item.virtualProductService.virtualProductServiceItems = [];
      }
    });
    //触发onChange
    if (onChange) onChange(_additionalItems);
  };

  const columns = [
    {
      title: getI18n(
        'subscriptionBuy.subscriptionBuy.productItems_ProductItemsTable_columns_productName_title',
      ),
      key: 'productName',
      dataIndex: 'productName',
      default: true,
      sorter: (a, b) => {
        //因为没有做分页，所以前端排序
        const name1 = a.productName || '';
        const name2 = b.productName || '';
        const n1 = name1.toLowerCase();
        const n2 = name2.toLowerCase();
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
        return 0;
      },
      render: (text, record) => {
        // console.log('record', record);
        const { productName } = record;
        const thumbnailUrl = get(record, 'thumbnailUrl');
        const image = get(record, 'image.url');
        return (
          <div className={css.productNameContainer}>
            <Image
              style={{
                marginRight: 12,
              }}
              width={40}
              height={40}
              key={thumbnailUrl || image}
              src={thumbnailUrl || image}
              alt={thumbnailUrl || image}
            />
            <NoWrapContainer>
              <GlobalTooltip title={productName || '-'}>
                <div className={css.text}>{productName || '-'}</div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
      ...widthDict['productName'],
    },
    {
      title: getI18n(
        'subscriptionBuy.subscriptionBuy.productItems_ProductItemsTable_columns_sku_title',
      ),
      key: 'sku',
      default: true,
      dataIndex: 'sku',
      ...widthDict['sku'],
    },
    {
      titleGenerate: () => (
        <span>
          {!nonOperational && <EditIcon />}
          {getI18n(
            'subscriptionBuy.subscriptionBuy.productItems_ProductItemsTable_columns_QTY_title',
          )}
        </span>
      ),
      key: 'QTY',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { amount, maximumPurchase } = record;
        const amountNumber = Number(amount);
        //判断输入的数量不能超过可选产品的数量，超过就用可选数量，有单个可选数量maximumPurchase，有总可选数量maxSelection
        const max =
          (maximumPurchase &&
            maxSelection &&
            maximumPurchase < maxSelection - checkedAmount + amountNumber) ||
          (maximumPurchase && !maxSelection)
            ? maximumPurchase
            : maxSelection
            ? maxSelection - checkedAmount + amountNumber
            : null;
        return !nonOperational ? (
          <TableNumberInputWithSlash
            itemProps={{
              min: 1,
              max: max,
              onBlur: (e) => {
                onQuantityChange(e, record[rowKeySet]);
              },
            }}
            value={amount}
            label={amount}
          />
        ) : (
          <NoWrapContainer>
            <GlobalTooltip title={amount || '-'}>{amount}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['qty'],
    },
    ...(!isGift
      ? [
          {
            titleGenerate: () => (
              <div>
                <div>
                  {getI18n(
                    'subscriptionBuy.subscriptionBuy.productItems_ProductItemsTable_columns_list_title',
                  )}
                </div>
                <div>({_currency})</div>
              </div>
            ),
            key: 'listPrice',
            default: true,
            //optional: false,
            // className: css.tableCol,
            position: EnumTablePosition.right,
            childGenerate: (text, record) => {
              // console.log('record', record);
              const { formattedListPrice } = record;
              const data = formattedListPrice ? formattedListPrice : '-';
              return (
                <NoWrapContainer>
                  <GlobalTooltip title={data}>{data || '-'}</GlobalTooltip>
                </NoWrapContainer>
              );
            },
            ...widthDict['listPrice'],
          },
        ]
      : []),
    ...(!isGift
      ? [
          {
            titleGenerate: () => (
              <div>
                <div>
                  {getI18n(
                    'subscriptionBuy.subscriptionBuy.productItems_ProductItemsTable_columns_Disc_title',
                  )}
                </div>
                <div>({_currency})</div>
              </div>
            ),
            key: 'Disc',
            default: true,
            position: EnumTablePosition.right,
            childGenerate: (text, record) => {
              const { formattedDiscountPrice, formattedListPrice } = record;
              return (
                <NoWrapContainer>
                  <GlobalTooltip
                    title={`-${formattedDiscountPrice || formattedListPrice}`}>
                    {formattedDiscountPrice || formattedListPrice
                      ? `-${formattedDiscountPrice || formattedListPrice}`
                      : '-'}
                  </GlobalTooltip>
                </NoWrapContainer>
              );
            },
            ...widthDict['discount'],
          },
        ]
      : []),

    ...(!isGift
      ? [
          {
            titleGenerate: () => (
              <div>
                <div>
                  {' '}
                  {getI18n(
                    'subscriptionBuy.subscriptionBuy.productItems_ProductItemsTable_columns_Selling_title',
                  )}{' '}
                </div>
                <div> ({_currency})</div>
              </div>
            ),
            key: 'sellingPrice',
            default: true,
            position: EnumTablePosition.right,
            childGenerate: (_, record) => {
              const { formattedSellingPrice } = record;
              return (
                <NoWrapContainer className={css.paidPrice}>
                  <GlobalTooltip title={formattedSellingPrice || 0}>
                    {formattedSellingPrice || 0}
                  </GlobalTooltip>
                </NoWrapContainer>
              );
            },
            ...widthDict['sellingPrice'],
          },
        ]
      : []),

    ...(extendColumns ? extendColumns : []),
  ];

  const handleCustomAdd = (uuid, data) => {
    const _additionalItems = cloneDeep(value || []);
    _additionalItems.forEach((item) => {
      if (item[rowKeySet] === uuid) {
        item.virtualProductService = item.virtualProductService || {};
        item.virtualProductService.virtualProductServiceItems = data;
      }
    });
    // console.log()

    if (onChange) onChange(_additionalItems);
  };
  return (
    <SizeFittingTable
      rowKey={rowKeySet}
      pagination={false}
      dataSource={value}
      className={css.detailTable}
      id={tableName}
      columns={columns}
      rowSelection={rowSelection}
      expandable={{
        expandedRowClassName: () => css.expandedRow,
        expandedRowRender: (record) => {
          //后端给了两个结构，只写了一个组件，所以判断一下，一个取不到，就是另一个
          const customisationItem =
            get(record, 'shopperProductCustomization.virtualServiceProduct') ||
            get(
              record,
              'virtualProductService.customisation.virtualServiceProduct',
            );
          const serviceDetails = get(
            customisationItem,
            'productService.serviceDetails',
          );
          //已经保存的customisation是在virtualProductService.virtualProductServiceItems里
          const virtualProductServiceItems = get(
            record,
            'virtualProductService.virtualProductServiceItems',
          );
          const exclusiveCustomData = (virtualProductServiceItems || []).map(
            (item) => {
              const customisationItemIndex = (serviceDetails || []).filter(
                (o) => o.uuid == item.productServiceDetailUuid,
              );
              return {
                title: `${
                  (customisationItemIndex[0] || {}).title
                } : ${item.values.toString()}`,
              };
            },
          );
          const skuItems = get(record, 'simpleProducts') || [];
          const optionValues = get(record, 'optionValues') || [];
          const uuid = get(record, rowKeySet) || [];
          const skuItemsOptions = skuItems.map((item) => [
            item.productName,
            item.sku,
          ]);
          if (!customisationItem && !skuItems.length && !optionValues.length) {
            return <React.Fragment />;
          }
          return (
            <React.Fragment>
              {!!optionValues.length && (
                <div className={css.optionValues}>
                  {optionValues.map((item, index) => (
                    <span key={index}>
                      {item.label}:{item.value},
                    </span>
                  ))}
                </div>
              )}
              {(!!skuItems.length || customisationItem) && (
                <div className={css.customizationLine}>
                  {!!skuItems.length && (
                    <div className={css.skuItems}>
                      <SkuItems data={skuItemsOptions} />
                    </div>
                  )}
                  {customisationItem && (
                    <ExclusiveCustom
                      data={exclusiveCustomData}
                      serviceDetails={serviceDetails}
                      disabled={disabled}
                      productName={record.productName}
                      defaultValue={virtualProductServiceItems}
                      sku={record.sku}
                      onAdd={(data) => handleCustomAdd(uuid, data)}
                      onRemove={() => handleRemove(uuid)}
                    />
                  )}
                </div>
              )}
            </React.Fragment>
          );
        },
        expandIconColumnIndex: -1,
        indentSize: 0,
        expandedRowKeys: expandedRows,
      }}
    />
  );
};

export default ProductItemsTable;
